import { ToastProvider } from '@/components/ui/Toasts';
import { queryClient, QueryClientProvider } from '@/lib/query-client';
import { ensureWebAdminAuthErrorBridge } from '@/lib/web-admin-auth-error-bridge';
import { AppRouter, router } from '@/pages/AppRoutes';
import { scheduleActivityTracking } from '@/telemetry/activity/start';
import { ProductAnalyticsAuthBridge } from '@/telemetry/ProductAnalyticsAuthBridge';

/**
 * Main App component.
 * Integrates the router with React Query and authentication providers.
 */
function App() {
  ensureWebAdminAuthErrorBridge();
  scheduleActivityTracking(router);

  return (
    <QueryClientProvider client={queryClient}>
      <ProductAnalyticsAuthBridge />
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
